const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://panagora-api.rosewrightfontaine.com',
  domain: process.env.REACT_APP_DOMAIN || 'panagora-admin.rosewrightfontaine.com',
  assetsUrl: process.env.REACT_APP_ASSETS_URL || '',
};

export default config; 